import { render, staticRenderFns } from "./PropSentimentTimeSeries.vue?vue&type=template&id=53c38f57&"
import script from "./PropSentimentTimeSeries.vue?vue&type=script&lang=js&"
export * from "./PropSentimentTimeSeries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports